<template>
  <div class="software">
    <AppBar />
    <div class="page-content">
      <div class="page-canvas">
        <div class="por-container">
          <div class="page-info">
            <div class="page-info-title">
              软件下载
            </div>
            <div class="page-info-describe">
              为企业创造更大的价值，让客户感动
            </div>
          </div>
        </div>
      </div>
      <div v-if="firstClassList.length>0" class="first-classification-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in firstClassList"
            :key="index"
            :label="item.title"
            :name="index+1+''"
          />
        </el-tabs>
        <div class="second-class-list">
          <div
            v-for="(item, index) in firstClassList[Number(activeName)-1].secondClassList"
            :key="index"
            class="second-class-item"
          >
            <div class="second-class-title">{{ item.title }}</div>
            <div class="file-list">
              <div
                v-for="(fileItem, fileIndex) in item.fileList"
                :key="fileIndex"
                class="file-item"
              >
                <div class="file-left">
                  <div class="circle"></div>
                  <div class="file-title">{{ fileItem.title }}</div>
                </div>
                <div class="file-right">
                  <div class="file-time">
                    {{ fileTime(fileItem.publishTime) }}
                  </div>
                  <div class="download-button" @click="downLoad(fileItem)">
                    立即下载
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild } from '@/api/column';
import { getContentList, getContentDetail, download } from '@/api/content';
import dayjs from 'dayjs';
export default {
  name: 'SoftwareView',
  data() {
    return {
      activeName: '1',
      firstClassList: [
        // {
        //   title: '硬件接口',
        //   secondClassList: [
        //     {
        //       title: '二级菜单1',
        //       fileList: [
        //         {
        //           fileName: '中控设备接口',
        //           time: '2022-12-07',
        //         },
        //       ],
        //     },
        //     {
        //       title: '二级菜单2',
        //       fileList: [
        //         {
        //           fileName: '中控设备接口',
        //           time: '2022-12-05',
        //         },
        //         {
        //           fileName: '海康设备接口',
        //           time: '2022-12-05',
        //         },
        //         {
        //           fileName: '身份证识别器接口',
        //           time: '2022-12-04',
        //         },
        //         {
        //           fileName: '这是一个可以修改标题的三级菜单',
        //           time: '2022-12-03',
        //         },
        //       ],
        //     },
        //   ],
        // },
      ],
    };
  },
  mounted() {
    this.getFirstMenu();
  },
  methods: {
    async getFirstMenu() {
      var { result, } = await getColumnChild({ parentId: '1605494229646401536', });
      for (var i = 0; i < result.length; i++) {
        var firstClass = {
          title: result[i].name,
          secondClassList: [],
        };
        var rrs = await getColumnChild({ parentId: result[i].id, });
        var rrsult = rrs.result;
        for (var j = 0; j < rrsult.length; j++) {
          var rts = await getContentList({ columnId: rrsult[j].id, pageNum: 1, pageSize: 99, });
          var rtsult = rts.result;
          var secondClass = {
            title: rrsult[j].name,
            fileList: rtsult.data,
          };
          firstClass.secondClassList.push(secondClass);
        }
        this.firstClassList.push(firstClass);
      }
      // getColumnChild({ parentId: '1605494229646401536', }).then((res) => {
      //   var { result, } = res;
      //   for (var i = 0; i < result.length; i++) {
      //     var firstClass = {
      //       title: result[i].name,
      //       secondClassList: [],
      //     };

      //     // getColumnChild({ parentId: result[i].id, }).then((rrs) => {
      //     //   console.log(result[i].id);
      //     //   var rrsult = rrs.result;
      //     //   // console.log(rrsult);
      //     //   for (var j = 0; j < rrsult.length; j++) {
      //     //     var secondClass = {
      //     //       title: rrsult[j].title,
      //     //       fileList: [],
      //     //     };
      //     //     getContentList({ columnId: rrsult[j].id, pageNum: 1, pageSize: 99, }).then((rts) => {
      //     //       var rtsult = rts.result;
      //     //       // console.log(rtsult.data);
      //     //       secondClass.fileList = rtsult.data;
      //     //       firstClass.secondClassList.push(secondClass);
      //     //     });
      //     //   }
      //     //   console.log(firstClass);
      //     // });
      //     this.firstClassList.push(firstClass);
      //   }
      // });
    },

    fileTime(time) {
      return dayjs(time).format('YYYY-MM-DD');
    },

    async downLoad(item) {
      const { result, } = await getContentDetail(item.id);

      var file = result.elements.find(obj => obj.name === 'file');

      if (file) {
        const content = file.content;
        download(content[0].url).then((rrs) => {
          const fileName = content[0].name;
          const blob = new Blob([ rrs.data, ]);
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // 兼容window.navigator.msSaveBlob：以本地方式保存文件
            window.navigator.msSaveBlob(blob, decodeURI(fileName));
          } else {
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob);
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a');
            tempLink.style.display = 'block';
            tempLink.href = blobURL;
            tempLink.setAttribute('download', decodeURI(fileName));
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
              tempLink.setAttribute('target', '_blank');
            }
            // 挂载a标签
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL);
          }
        });
      }
    },

    handleClick(tab, event) {
    },
    openBealter() {
      this.$refs.altProduct.tobealter();
       },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less" scoped>
.software{
  background-color: #fff;
  position: relative;
  .page-content{
    width: 100%;
    box-sizing: border-box;
    .page-canvas{
        width: 100%;
        height: 360px;
        min-width: var(--minwidth);
        background: url('@/assets/software/canvas.png') no-repeat;
        background-size: cover;
        background-position: center;
        .por-container{
          width: 70%;
          min-width: var(--minwidth);
          height: 100%;
          margin: 0 auto;
          position: relative;
          .page-info{
            width: 100%;
            height: 100%;
            padding-top: 119px;
            box-sizing: border-box;
            .page-info-title{
              font-family: OPPOSans-R;
              font-size: 36px;
              color: #fff;
              margin-bottom: 20px;
            }
            .page-info-describe{
              font-family: OPPOSans-R;
              font-size: 20px;
              color: #fff;
            }
          }
        }
    }
    .first-classification-wrap{
      width: 100%;
    //   display: flex;
    //   justify-content: center;
      padding-top: 30px;
      box-sizing: border-box;
      ::v-deep .el-tabs{
        width: 100%;
        .el-tabs__header{
          margin: 0;
          .el-tabs__nav-scroll{
            display: flex;
            justify-content: center;
            .el-tabs__active-bar{
                background-color: #53d6f5;
            }
            .el-tabs__item{
                margin: 15px 0;
                padding: 0 23px;
                font-family: OPPOSans-R;
                font-size: 18px;
                color: #21252b;
            }
          }
        }
      }
      .second-class-list{
        width: 1200px;
        margin: 0 auto;
        padding: 40px 0;
        .second-class-item{
            width: 100%;
            background-color: #fff;
            border: 1px solid #ebe8e8;
            padding: 0 20px 30px;
            box-sizing: border-box;
            margin-bottom: 20px;
            .second-class-title{
                font-size: 18px;
                font-family: OPPOSans-M;
                line-height: 1;
                padding: 25px 0;
                border-bottom: 1px solid #ebe8e8;
            }
            .file-list{
                .file-item{
                    width: 100%;
                    height: 70px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 1px solid #ebe8e8;
                    box-sizing: border-box;
                    .file-left{
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        .circle{
                            width: 12px;
                            height: 12px;
                            background-color: #fff;
                            border: 1px solid #00b0dc;
                            border-radius: 50%;
                            margin-right: 30px;
                        }
                        .file-title{
                            font-size: 14px;
                            font-family: OPPOSans-R;
                            color: #21252b;
                        }
                    }
                    .file-right{
                        .file-time{
                          font-size: 14px;
                          font-family: OPPOSans-R;
                          color: 21252b;
                          display: block;
                        }
                        .download-button{
                            width: 100px;
                            height: 36px;
                            background-color: #fff;
                            border-radius: 2px;
                            border: 1px solid #00b0dc;
                            font-size: 14px;
                            font-family: OPPOSans-R;
                            color: #00b0dc;
                            text-align: center;
                            line-height: 36px;
                            box-sizing: border-box;
                            display: none;
                            cursor: pointer;
                            &:hover{
                                background-color: #00b0dc;
                                color: #fff;
                            }
                        }
                    }
                    &:hover{
                        .file-right{
                            .file-time{
                                display: none;
                            }
                            .download-button{
                                display: block;
                            }
                        }
                    }
                }
            }
        }
      }
    }
  }
}
</style>
